import React from "react";
import { AlertCircle } from "lucide-react";

/**
 * A field wrapper: label + control slot + hint + error.
 * Keeps every field in the form visually consistent without forcing
 * any specific control implementation.
 */
const Field = ({
  label,
  required,
  hint,
  error,
  htmlFor,
  children,
  action,
  className = "",
}) => {
  const labelEl = label ? (
    <label
      htmlFor={htmlFor}
      className={`pf-field__label ${
        required ? "pf-field__label--required" : ""
      }`}
    >
      {label}
    </label>
  ) : null;

  return (
    <div className={`pf-field ${className}`}>
      {labelEl && action ? (
        <div className="pf-field__label-row">
          {labelEl}
          {action}
        </div>
      ) : (
        labelEl
      )}
      {children}
      {hint && !error ? <div className="pf-field__hint">{hint}</div> : null}
      {error ? (
        <div className="pf-field__error">
          <AlertCircle size={12} />
          {error}
        </div>
      ) : null}
    </div>
  );
};

export default Field;
